import * as React from "react";
import { observer, inject } from "mobx-react";
import { observable, runInAction } from "mobx";

import { Category, CategoryType, CategoryImage } from "../../models";

import CategoryItemCardContainer, {
    CategoryItemCardContainerProps,
    calculateSizes,
    renderImage,
    renderLine,
} from "./CategoryItemCardContainer";
import {
    VocabularyCard,
    ExpressionCard,
    TextOnlyCard,
    ExpressionTextOnlyCard,
    LessonCard,
    ImageOnlyCard,
} from "./CategoryItemCardComponents";

// Layout
import { Row, Col } from "../../layout";
import { computed } from "mobx";
import { ActivityCategoryItem } from "models/customLists/CategoryItem";

export interface CategoryItemCardProps extends CategoryItemCardContainerProps {
    item: ActivityCategoryItem;
    title?: string;
    category: Category;
    lessonSelection?: CategoryType;
    cardTypeOverride?: CategoryType;
    showWrongAnswers?: boolean;
    hideVocabularyAnswer?: boolean;
}

@inject("rootStore")
@observer
export default class CategoryItemCard extends React.Component<CategoryItemCardProps> {
    @observable private showWrongAnswers = false;

    constructor(props: CategoryItemCardProps) {
        super(props);
        if (props.showWrongAnswers != undefined) {
            runInAction(() => {
                this.showWrongAnswers = props.showWrongAnswers;
            });
        }
    }

    @computed
    get imageURL(): string {
        if (this.props.item !== undefined) {
            return this.props.item.imageURL;
        }
    }

    @computed
    get sizes(): any {
        return calculateSizes(this.props.cardHeight, this.props.cardWidth, this.props.fontSize);
    }

    componentDidUpdate(newProps: CategoryItemCardProps) {
        if (newProps.showWrongAnswers != undefined) {
            runInAction(() => {
                this.showWrongAnswers = newProps.showWrongAnswers;
            });
        }
    }

    render() {
        if (!this.props.rootStore) {
            return null;
        }

        let { lessonSelection, showWrongAnswers, rootStore, ...other } = this.props;
        return (
            <CategoryItemCardContainer {...other}>
                {this.props.children}
                {this.renderChildren()}
            </CategoryItemCardContainer>
        );
    }

    renderChildren() {
        return (
            <Col xs={12}>
                <Row center="xs">{this.cardContentForItem(this.props.item)}</Row>
            </Col>
        );
    }

    private cardContentForItem(categoryItem: ActivityCategoryItem | CategoryImage) {
        let { audioStore } = this.props.rootStore;

        let longestItem = this.props.category.longestItem;
        if (categoryItem instanceof ActivityCategoryItem) {
            let type = this.props.cardTypeOverride
                ? this.props.cardTypeOverride
                : categoryItem.typeForLessonSelection(this.props.lessonSelection);
            let cardProps = {
                audioStore: audioStore,
                categoryItem: categoryItem,
                longestItem: longestItem,
                height: this.sizes.height,
            };
            switch (type) {
                case CategoryType.ImageOnly:
                    return <ImageOnlyCard {...cardProps} />;

                case CategoryType.Vocabulary:
                    return <VocabularyCard {...cardProps} />;

                case CategoryType.VocabularyTextOnly:
                    return <TextOnlyCard {...cardProps} />;

                case CategoryType.Expression:
                    Object.assign(cardProps, { showWrongAnswers: this.showWrongAnswers });
                    return <ExpressionCard {...cardProps} />;

                case CategoryType.ExpressionTextOnly:
                    Object.assign(cardProps, { showWrongAnswers: this.showWrongAnswers });
                    return <ExpressionTextOnlyCard {...cardProps} />;

                case CategoryType.Lesson:
                    Object.assign(cardProps, { showWrongAnswers: this.showWrongAnswers });
                    return <LessonCard {...cardProps} />;

                default:
                    return null;
            }
        } else if (categoryItem instanceof CategoryImage) {
            return (
                <Col xs={true}>
                    {this.imageURL && renderImage(this.imageURL, this.sizes.height * 0.8)}
                    {renderLine(categoryItem.title, this.props.rootStore.audioStore, "Test", this.sizes.height * 0.1)}
                </Col>
            );
        }
    }
}
